import React, { useRef, useState, forwardRef, useImperativeHandle, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import DynamicList from '../../widgets/DynamicList';
import SliderList from './SliderList';
import { apiRequestAsyncThunk } from '../../thunk/CommonThunk';
import { CRUD_SLIDER, GET_SLIDERS } from '../../api/Api';
import { $serializeForm } from '../../main';
import { Loading } from '../Loaders';
import { LoadingSvg, SaveSvg } from '../../icons/Icon';

const SliderManager = (p) => {

    const sliderList = useRef(null);
    const dispatch = useDispatch();
    const  [sliders, setSliders] = useState(null);

    const loadSliders = (e) => {
        dispatch(apiRequestAsyncThunk({
            request_details: GET_SLIDERS,
            call: showSliders,
            messages: {
                loading: 'Loading sliders',
                done: 'Sliders loaded',
                error: 'Error loading sliders'
            }
        }));
    }
    const showSliders = (state, data) => {
        //console.log('Menu.showMainMenu', state, data?.data);
        switch (state) {
            case 'loading':
                setSliders(<Loading><LoadingSvg /></Loading>);
                break;
            case 'done':
                let sliders = data.data;
                setSliders(<SliderList ref={sliderList} data={sliders} />);
                break;
            case 'error':
                setSliders(<SliderList ref={sliderList} data={[]} />);
                break;
        }
    }
    useEffect(() => {
        loadSliders();
    }, []);

    const onGet = () => {
        dispatch(apiRequestAsyncThunk(CRUD_SLIDER.GET, {}));
    };
    const onSave = () => {
        let data = sliderList.current.getData();
        let list = sliderList.current.getList();
        const formData = new FormData();
        console.log('sliderList', list);

        list.forEach((slide, index) => {
            let id = slide.id;
            if(data[id]){
                let form = data[id].form;
                let images = data[id].image.getImages();
                let image = (Array.isArray(images) && images.length > 0) ? images[0] : null;
                let [encoded, decoded] = $serializeForm(form.getForm());
                formData.append(`${id}[form]`, JSON.stringify(decoded));    
                //formData.append(`${id}[image]`, (Array.isArray(images) && images.length > 0) ? images[0].file : '');
                console.log(image);
                formData.append(`${id}[image]`, image ? JSON.stringify({name: image.name, newName: image.newName, order: image.order}) : '');
                formData.append(`${id}[order]`, slide.order);
                formData.append(`images[${id}]`, image?.file || '');
            }
        });
        //formData.forEach((value, key) => {console.log(`${key}: ${value}`);});

        dispatch(apiRequestAsyncThunk({
            request_details: CRUD_SLIDER(formData),
            call: (state, data) => {
                console.log('CRUD_SLIDER', state);
                if(state == 'done' || state == 'error'){
                    loadSliders();
                }
            },
            messages: {
                loading: 'Saving',
                done: 'done',
                error: 'error'
            }
        }));
    }

    return (
        <div className="page">
            <div className="flex-24">
                <div className="col-24 flex-column">
                    <div className="page-box">
                        <div className='page-box-header'>
                            <h4><span>Sliders</span><button className="page-box-header-yellow" onClick={onSave}><SaveSvg />save</button></h4>
                        </div>
                        <div className='page-box-body'>
                            {sliders}
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default SliderManager;